import { useConnectModal } from '@rainbow-modules/hooks';
import { ADD_EDIT_PHONE_NUMBER_MODAL } from '../../constants';
import Fields from './fields';
import {
    FormHeader, FormHeaderTitle, FormHeaderDescription, StyledModal,
} from './styled';

const AddEditPhoneNumberModal = () => {
    const {
        title, subtitle, ...connectedModalProps
    } = useConnectModal(ADD_EDIT_PHONE_NUMBER_MODAL);

    return (
        <StyledModal
            {...connectedModalProps}
            fields={Fields}
            title={(
                <FormHeader>
                    <FormHeaderTitle>{title}</FormHeaderTitle>
                    <FormHeaderDescription>{subtitle as string}</FormHeaderDescription>
                </FormHeader>
            )}
        />
    );
};

export default AddEditPhoneNumberModal;
